import { get } from 'lodash'
import users from './users'
import request from 'superagent'

import { getListingInfo } from '../helpers/listingHelpers'
import authHelpers from '../../helpers/authHelpers'

const creditLimit = {
  retrieve: (auctionUuid) => {
    return async (dispatch, getState) => {
      let { maxSpend, biddingStatus } = getState().creditLimit

      dispatch({
        type: 'USER_SPENDING_LIMIT_GET'
      })

      try {
        const session = await dispatch(users.getUserSession())
        maxSpend = get(session, 'session.maxSpend', maxSpend)
        biddingStatus = get(session, 'session.biddingStatus', biddingStatus)
        if (biddingStatus !== 'active') {
          return dispatch({
            type: 'USER_SPENDING_LIMIT_SESSION_CHECK_FAILED',
            err: 'invalid_session'
          })
        }
      } catch (err) {
        console.error('>>>> retrieve', err)
        // TODO: gracefully revert back to the previous credit limit and proceed with the rest of the app
        return dispatch({
          type: 'USER_SPENDING_LIMIT_SESSION_CHECK_FAILED_2',
          err
        })
      }

      const bids = getState().bids.bids
      const maxBids = getState().maxBids.maxBidsByListingUuid
      const listings = getState().lots.listings
      const saleStatus = getState().saleStatuses.saleStatuses
      const sales = getState().listingSales.sales
      const userUuid = getState().users.user.uuid
      const filteredBids = {}
      const filteredMaxBids = {}
      const combinedBids = {}
      const soldLots = {}

      Object.values(listings).forEach(listing => {
        const listingUuid = listing.uuid
        const status = saleStatus?.[listingUuid]
        const maxBid = maxBids?.[listingUuid]
        const highestBid = status?.highestBidUuid ? bids?.[status?.highestBidUuid] : null
        const sale = sales?.[listingUuid]
        const isLot = listing.type === 'lot'

        if (listing.auctionUuid === auctionUuid) {
          const {
            isPassedIn,
            // isSold,
            isSoftSold,
            isWithdrawn,
            hasEnded
          } = getListingInfo(listing, listing?.specs, status, bids, sale, isLot)

          if (userUuid === highestBid?.userUuid) {
            // if (!isSold && !isWithdrawn && !isPassedIn) { // * we want to include sold lots here so user can see what they have won against their credit limit
            if (!isWithdrawn && !isPassedIn) {
              // ! Don't need this since it's being regenerated every time
              // if (!filteredBids?.[listingUuid] || filteredBids[listingUuid] < status.currentBid) {
              //   // console.log('>>>> Listing status', status, sale)
              //   filteredBids[listingUuid] = highestBid.amount
              //   combinedBids[listingUuid] = highestBid.amount
              // }
              filteredBids[listingUuid] = highestBid.amount
              combinedBids[listingUuid] = highestBid.amount
            }

            if (isSoftSold) {
              soldLots[listingUuid] = highestBid.amount
            }
          }

          // override highest bid if max bid is higher
          if (!isSoftSold && !hasEnded && !isWithdrawn && maxBid?.userUuid === userUuid && maxBid?.value > highestBid?.amount) {
            filteredMaxBids[listingUuid] = maxBid.value
            combinedBids[listingUuid] = maxBid.value
            // console.log('>>>> ---- A B', maxBid)
          }
        }
      })

      const currentSpend = Object.values(combinedBids).reduce((total, bid) => total + bid, 0)
      // console.log('>>>>>>> ---- A ', { bids: filteredBids, maxBids: filteredMaxBids })
      return dispatch({
        type: 'USER_SPENDING_LIMIT_SUCCESS',
        session: {
          biddingStatus: biddingStatus,
          maxSpend: maxSpend,
          currentSpend: currentSpend
        },
        bids: filteredBids,
        maxBids: filteredMaxBids,
        soldLots: soldLots
      })
    }
  },
  reset: () => {
    return (dispatch) => {
      dispatch({
        type: 'USER_SPENDING_LIMIT_RESET'
      })
    }
  },
  enquiry: ({ userId, auctionId, amount, message }) => {
    return (dispatch, getState) => {
      dispatch({
        type: 'CREDIT_ENQUIRY'
      })

      const oAuthConfig = getState().config.input.options.oAuth
      const tokenName = oAuthConfig.tokenName
      const thirdPartyToken = authHelpers.getCookie(tokenName)

      if (!thirdPartyToken) {
        return dispatch({
          type: 'CREDIT_ENQUIRY_FAILED',
          err: 'No token found'
        })
      }

      try {
        return request.post(`${oAuthConfig.ssoLoginUrl}/credit-enquiry`)
          .set('Content-Type', 'application/json')
          .set('Authorization', `Bearer ${thirdPartyToken}`)
          .send({
            userId,
            auctionId,
            amount,
            message
          })
          .then(response => {
            if (get(response, 'body.status_code') === 200) {
              return dispatch({
                type: 'CREDIT_ENQUIRY_SUCCESS'
              })
            }
            return dispatch({
              type: 'CREDIT_ENQUIRY_FAILED',
              err: 'invalid_response'
            })
          })
          .catch(err => {
            return dispatch({
              type: 'CREDIT_ENQUIRY_FAILED',
              err: err
            })
          })
      } catch (err) {
        console.error('>>>> enquiry', err)
        return dispatch({
          type: 'CREDIT_ENQUIRY_FAILED',
          err
        })
      }
    }
  }
}

export default creditLimit
